/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {ApexOptions} from 'apexcharts'
import {KTSVG} from '../../../helpers'
import {getCSSVariableValue} from '../../../assets/ts/_utils'
import {useGetUserMetrics} from "../../../api/hooks";
import {IFormValue} from "../../../../app/pages/dashboard/DashboardWrapper";

type Props = {
  className: string
  formValue: IFormValue
}

const MixedWidget2: React.FC<Props> = ({className , formValue}) => {
const {data} = useGetUserMetrics({active_users_from:formValue.fromDate, active_users_to:formValue.toDate})
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className={`h-50 `}>
        <h3 className='d-flex w-100 justify-content-between align-items-center fw-bold text-gray-800 bg-light-success w-100 h-50px p-4 rounded-top bg-light-danger w-100 h-50px p-4 rounded-top'>User Metrics <KTSVG
            path='/media/icons/duotune/general/gen032.svg'
            className='svg-icon-3x svg-icon-danger d-block my-2'
        /></h3>

      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body p-0'>
        {/* begin::Chart */}

        {/* end::Chart */}
        {/* begin::Stats */}
        <div className='p-3'>
          {/* begin::Row */}
          <div className='row g-0'>
            {/* begin::Col */}
            <div className='col bg-light-warning px-4 py-8 rounded-2 me-3 mb-3 d-flex flex-column justify-content-between align-items-center'>
              <p className='text-warning fw-semibold fs-6 text-center'>
                Total Registered Users
              </p>
              <p className='text-warning fw-semibold fs-6'>
                {data?.total_registered_users}
              </p>
            </div>
            {/* end::Col */}

            {/* begin::Col */}
            <div className='col bg-light-warning px-4 py-8 rounded-2 mb-3 d-flex flex-column justify-content-between align-items-center'>
              <p className='text-warning fw-semibold fs-6 text-center' >
                Active Users (last 30 days)
              </p>
              <p className='text-warning fw-semibold fs-6'>
                {data?.monthly_active_users?.count}
              </p>
            </div>
            {/* end::Col */}
          </div>
          {/* end::Row */}
          {/* begin::Row */}
          <div className='row g-0'>
            {/* begin::Col */}
            <div className='col bg-light-primary px-4 py-8 rounded-2 me-3 mb-3 d-flex flex-column justify-content-between align-items-center'>
              <p className='text-primary fw-semibold fs-6 text-center text-center' >
                New Signup Users (last 30 days)
              </p>
              <a href='#' className='text-primary fw-semibold fs-6 text-center'>
                {data?.new_sign_ups?.count}
              </a>
            </div>
            {/* end::Col */}

            {/* begin::Col */}
            <div className='col bg-light-primary px-4 py-8 rounded-2 mb-3  d-flex flex-column justify-content-between align-items-center'>
              <p className='text-primary fw-semibold fs-6 text-center text-center' >
                Daily Active Users
              </p>
              <a href='#' className='text-primary fw-semibold fs-6 text-center'>
                {data?.daily_active_users?.count}
              </a>
            </div>
            {/* end::Col */}
          </div>
          {/* end::Row */}
          {/* begin::Row */}
          <div className='row g-0'>
            {/* begin::Col */}
            <div className='col bg-light-danger px-4 py-8 rounded-2 d-flex flex-column justify-content-between align-items-center'>
              <p className='text-danger fw-semibold fs-6 text-center text-center' >
                Monthly Active Users
              </p>
              <a href='#' className='text-danger fw-semibold fs-6 text-center'>
                {data?.monthly_active_users?.count}
              </a>
            </div>
            {/* end::Col */}
            {/* begin::Col */}
            {/*<div className='col bg-light-danger px-4 py-8 rounded-2 d-flex flex-column justify-content-between align-items-center'>*/}
            {/*  <p className='text-danger fw-semibold fs-6 text-center text-center' >*/}
            {/*    User Retention (30 days Retention Rate)*/}
            {/*  </p>*/}
            {/*  <a href='#' className='text-danger fw-semibold fs-6 text-center'>*/}
            {/*    {data?.monthly_active_users.count}*/}
            {/*  </a>*/}
            {/*</div>*/}
            {/* end::Col */}
          </div>
          {/* end::Row */}
        </div>
        {/* end::Stats */}
      </div>
      {/* end::Body */}
    </div>
  )
}

const chartOptions = (
  chartHeight: string,
  chartColor: string,
  strokeColor: string
): ApexOptions => {
  const labelColor = getCSSVariableValue('--kt-gray-500')
  const borderColor = getCSSVariableValue('--kt-gray-200')
  const color = getCSSVariableValue('--kt-' + chartColor)

  return {
    series: [
      {
        name: 'Net Profit',
        data: [30, 45, 32, 70, 40, 40, 40],
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: chartHeight,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: true,
        enabledOnSeries: undefined,
        top: 5,
        left: 0,
        blur: 3,
        color: strokeColor,
        opacity: 0.5,
      },
    },
    plotOptions: {},
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      opacity: 0,
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [strokeColor],
    },
    xaxis: {
      categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      crosshairs: {
        show: false,
        position: 'front',
        stroke: {
          color: borderColor,
          width: 1,
          dashArray: 3,
        },
      },
    },
    yaxis: {
      min: 0,
      max: 80,
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return '$' + val + ' thousands'
        },
      },
      marker: {
        show: false,
      },
    },
    colors: ['transparent'],
    markers: {
      colors: [color],
      strokeColors: [strokeColor],
      strokeWidth: 3,
    },
  }
}

export {MixedWidget2}
